// import library
import axios from "axios";
import { useTranslation } from "react-i18next";
// import component
import Layout from "../../layouts/Layout";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import FilterFormLayout from "../../components/Common/Table/FilterFormLayout";
// files
import { env } from "../../env";
import LoaderIcon from "../../components/Common/Icon/Loader";
import AddNewCouponPopUpComponent from "../../components/Profile/AddNewCouponPopUpComponent";
import WarningPopUp from "../../components/Profile/WarningPopUp";
import { AuthContext } from "../../context";

const CreateCoupon = () => {
    // variables
    const { t } = useTranslation();
    const location = useLocation();
    const customerId = location.pathname.split('/')[3];
    const [isLoader, setIsLoader] = useState(true);
    const navigate = useNavigate();
    const authContext = useContext(AuthContext);
    const storedVisitData = localStorage.getItem('visit');
    const initialVisitData = storedVisitData ? JSON.parse(storedVisitData) : {};
    const [visitTypeData, setVisitTypeData] = useState(initialVisitData);
    const [showWarningPopUp, setShowWarningPopUp] = useState(false);
    
    const [sortTypesList, setSortTypesList] = useState([
        {
            "name" : "name - top to bottom",
            "field" : "name",
            "type" : "asc"
        },
        {
            "name" : "name - bottom to top",
            "field" : "name",
            "type" : "desc"
        },
    ]);

    const [showSort, setShowSort] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [showPopUp, setShowPopUp] = useState(false);
    const [showInformation, setShowInformation] = useState(false);

    const [searchTerm, setSearchTerm] = useState("");
    const [sortType, setSortType] = useState("");
    const [sortField, setSortField] = useState("");
    const [sortName, setSortName] = useState("");

    const [defaultProductImage, setDefaultProductImage] = useState("");
    const [couponLists, setCouponLists] = useState([]);
    const [currentCoupon, setCurrentCoupon] = useState({});
    const [currentValue, setCurrentValue] = useState({});

    const handleShowInformation = (e, value) => {
        e.preventDefault();
        setCurrentValue(value);
        setShowInformation(!showInformation);
    };

    useEffect(() => {
        const fetchData = async () => {
            const baseUrl = env.REACT_APP_API_URL;
            const token = localStorage.getItem('token');

            await getDefaultProductImage(baseUrl, token);
            await getAllCouponListApi(baseUrl, token);
        };
        fetchData();
    }, []);
    // tab change
    const handleTabCheckDataFromChild = (data) => {
        if((visitTypeData && visitTypeData.visitId) && data.tab === 'profile') {
            setShowWarningPopUp(!showWarningPopUp)
        } else {
            if(data.link === '/logout') {
                authContext.logout();
            } else {
                navigate(data.link);
            }
            localStorage.removeItem("profile_tab");
        }
    };
    const handleWarningPopUpDataFromChild = (data) => {
        setShowWarningPopUp(!showWarningPopUp);
        if(data === 'complete') {
            setVisitTypeData({});
        }
    };
    // function
    const getDefaultProductImage = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+"/api/User/GetDefaultImage",{ headers })
        .then((response) => {
            setDefaultProductImage(response.data.productDefaultImage);
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const getAllCouponListApi = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };
        await axios.get(url+`/api/OfflineSync/GetAllCouponList?customerid=${customerId}`,{ headers })
        .then((response) => {
            setCouponLists(response.data);
            setIsLoader(false);
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const handleSearch = (e) => {
        e.preventDefault();
    };
    const handleShowSort = (e) => {
        e.preventDefault();
        setShowSort(!showSort);
    };
    const handleShowFilter = (e) => {
        e.preventDefault();
        setShowFilter(!showFilter);
    };
    const handleSortType = (e, data) => {
        e.preventDefault();
        setSortName(data.name);
    };
    const handleModalCloseDataFromChild = (data) => {
        setShowPopUp(data);
    };
    const handleShowPopUp = (data) => {
        setCurrentCoupon(data);
        setShowPopUp(!showPopUp);
    };
    
    return (
        <div className="relative">
            <Layout sendTabCheckDataFromChild={handleTabCheckDataFromChild}>
                <div className="flex justify-between items-center">
                    <div className="w-44 sm:w-auto">
                        <h1 className="text-base sm:text-2xl font-semibold capitalize">{ t('add new coupon') }</h1>
                        <div className="text-light-400 text-[10px] w-max sm:w-auto sm:text-sm capitalize flex items-center cursor-pointer"><NavLink to={`/profiles/detail/${customerId}`}>{ t('customer detail') }</NavLink>/{ t('new coupon') }</div>
                    </div>
                    {/* <div className="flex justify-between items-center space-x-1 sm:space-x-2">
                        <div className="border border-gray-dark1 cursor-pointer bg-white rounded-lg hidden sm:flex items-center px-4 py-2">
                            <img className="w-4" src="../../../assets/icons/search.svg" alt="search" />
                            <div className="pl-4">
                                <input className="border-none bg-white focus:outline-none w-44 sm:w-32 lg:w-80 placeholder:capitalize" type="text" onKeyDown={(e) => handleSearch(e)} onKeyPress={(e) => handleSearch(e)} placeholder={t('search')+"..."} />
                            </div>
                        </div>
                        <div className="flex items-center justify-end space-x-1 sm:space-x-2">
                            <div className="relative"> 
                                <div className="flex w-fit items-center cursor-pointer bg-black-300 rounded-lg py-2.5 sm:py-2 px-2.5 sm:px-4" onClick={(e) => handleShowSort(e)}>
                                    <img className="sm:w-6 sm:h-6" src="../../../assets/icons/table/sort.svg" alt="sort" />
                                    <div className="hidden lg:block ml-2 text-blue-normal font-medium text-xl capitalize">{ t('sort')}</div>
                                </div>
                                {
                                    showSort 
                                    ?
                                        <ul className="z-20 py-3 bg-white top-12 absolute right-0 border border-white shadow-md rounded-[10px] w-max text-left overflow-y-auto no-scrollbar">
                                            {sortTypesList.map((value, index) => (
                                                <li key={index} onClick={(e) => handleSortType((e), value)} className={(sortName === value.name ? "bg-action-hover" : "bg-white") + " hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize text-xs"}>{ t(value.name)}</li>
                                            ))}
                                        </ul>
                                    : null
                                }
                            </div>
                            <div className="relative">
                                <div className="flex w-fit text-right items-center cursor-pointer bg-black-300 rounded-lg py-2.5 sm:py-2 px-3 sm:px-4" onClick={(e) => handleShowFilter(e)}>
                                    <img className="sm:w-5" src="../../../assets/icons/table/filter.svg" alt="filter" />
                                    <div className="hidden lg:block ml-2 text-blue-normal font-medium text-xl capitalize">{ t('filter')}</div>
                                </div>
                                {
                                    showFilter 
                                    ?
                                        <FilterFormLayout>
                                            <div>
                                                test
                                            </div>
                                        </FilterFormLayout>
                                    : null
                                }
                            </div>
                            <div className="block sm:hidden">
                                <NavLink to={`/profiles/detail/${customerid}`}>
                                    <div className="bg-black-100 flex items-center p-3 sm:p-4 rounded-lg">
                                        <img className="sm:w-3 sm:h-3" src="../../../assets/icons/profile/cancel.svg" alt="cancel" />
                                    </div>
                                </NavLink>
                            </div>
                        </div>
                    </div> */}
                    <div className="hidden sm:block">
                        <NavLink to={`/profiles/detail/${customerId}`}>
                            <div className="bg-black-100 flex items-center p-3 sm:p-4 rounded-lg">
                                <img className="sm:w-3 sm:h-3" src="../../../assets/icons/profile/cancel.svg" alt="cancel" />
                            </div>
                        </NavLink>
                    </div>
                </div>
                {/* <div className="block sm:hidden bg-white p-2 rounded-lg">
                    <div className="border border-gray-dark1 cursor-pointer bg-white rounded-lg flex items-center py-2 px-2 sm:px-4">
                        <img className="w-4" src="../../../assets/icons/search.svg" alt="search" />
                        <div className="pl-4">
                            <input className="border-none bg-white focus:outline-none w-44 sm:w-32 lg:w-80 placeholder:capitalize" type="text" onKeyDown={(e) => handleSearch(e)} onKeyPress={(e) => handleSearch(e)} placeholder={t('search')+"..."} />
                        </div>
                    </div>
                </div> */}
                { isLoader
                    ?
                        <LoaderIcon />
                    :
                        couponLists.length > 0 ?
                            <div className="grid lg:grid-cols-2 xl:grid-cols-3 gap-2">
                                {couponLists.map((coupon, index) => (
                                    <div key={`coupon${index}`} className="rounded-xl bg-white flex p-2 space-x-2 justify-between">
                                        <div className="relative w-28">
                                            <img className="w-14 h-14 sm:w-20 sm:h-20 rounded-lg border border-background-normal" src={defaultProductImage} alt="product-img" />
                                            <div onClick={(e) => handleShowInformation(e, coupon)} className="absolute right-0 bottom-0 bg-white rounded-md p-1 shadow-md cursor-pointer">
                                                <img src={`../../assets/icons/profile/information.svg`} alt="information" />
                                            </div>
                                        </div>
                                        <div className="flex flex-col justify-evenly w-full">
                                            <h1 className="font-semibold text-xs sm:text-base capitalize">{coupon.BatchName}</h1>
                                            <div className="flex justify-between space-x-1 items-center w-full text-[10px] sm:text-xs">
                                               {coupon.Description}
                                            </div>
                                            <div className="flex justify-between items-center text-[10px] sm:text-xs">
                                                <div className="capitalize text-light-700">{ t('expiry')}: <span className="font-medium text-black">{coupon.Expiry}</span></div>
                                            </div>
                                        </div>
                                        <img onClick={(e) => handleShowPopUp(coupon)} className="cursor-pointer"  src="../../../assets/icons/profile/plus_light.svg" alt="plus_light" />
                                    </div>
                                ))}
                            </div>
                        :
                        <div className="p-4 text-center font-bold text-xs sm:text-xl rounded-lg capitalize bg-white">
                            { t('no data available')}
                        </div>
                }
            </Layout>
            {/* page */}
            {showPopUp && (
                <AddNewCouponPopUpComponent customerId={customerId} currentCoupon={currentCoupon} sendModalCloseDataFromChild={handleModalCloseDataFromChild} />
            )}
            {showInformation && (
                <div className="fixed z-50 overflow-y-auto top-0 w-full left-0 h-full">
                    <div className="flex items-center justify-center min-height-100vh pt-4 px-4 pb-20 text-center sm:block sm:p-0 h-full">
                        <div className="fixed inset-0 transition-opacity">
                            <div className="absolute inset-0 bg-gray-900 opacity-75" />
                        </div>
                        <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>
                        <div className="inline-block align-center bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-sm w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                            <div className="bg-white p-4 space-y-3">
                                <div className="flex justify-between items-center">
                                    <div className="font-semibold text-sm sm:text-lg capitalize">{currentValue.BatchName}</div>
                                    <div className="cursor-pointer" onClick={(e) => setShowInformation(!showInformation)}>
                                        <img src="../../../assets/icons/modal-cross.svg" alt="cross" />
                                    </div>
                                </div>
                                <div className="rounded-lg py-2 px-2 border border-background-normal text-black">
                                    <h1 className="capitalize font-semibold">{ t('description')}</h1>
                                    <p className="text-light-700 text-sm">{currentValue.Description}</p>
                                </div>
                                <div className="text-right">
                                    <button type="button"  onClick={(e) => setShowInformation(!showInformation)} className="uppercase border border-background-normal text-light-700 rounded-lg py-1 px-4">ok</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/* commmon */}
            {showWarningPopUp && <WarningPopUp customerId={customerId} visitTypeData={visitTypeData} sendWarningPopUpDataFromChild={handleWarningPopUpDataFromChild} /> }
        </div>
    )
}

export default CreateCoupon;